import { BuildingContext } from "Context/BuildingProvider";
import { AuthContext } from "Firebase/AuthProvider";
import { Fragment, useContext, useEffect, useState } from "react";
import { useTheme } from "styled-components";
import { useStyles } from "Theme/styles";
import {
  Box,
  LinearProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import PerfectScrollbar from "react-perfect-scrollbar";
import { getPrettyDateString } from "helpers/FormatHelper";
import { GetRolesQueryResult } from "generated/graphql";
import { useQuery } from "@apollo/client";
import { GET_ROLES } from "lib/roles";

interface RoleTableRow {
  taskName: string;
  roleName: string;
  timeString: string;
  priority: number;
}

interface PendingTasksTableState {
  loading: boolean;
  roleTableRows: RoleTableRow[];
}

const DEFAULT_STATE: PendingTasksTableState = {
  loading: true,
  roleTableRows: [],
};

export default function PendingTasksTable() {
  const [state, setState] = useState<PendingTasksTableState>(DEFAULT_STATE);
  const { getDatabase } = useContext(AuthContext);
  const { currentBuilding } = useContext(BuildingContext);
  const {
    loading: rolesLoading,
    error,
    data,
  }: GetRolesQueryResult = useQuery(GET_ROLES, {
    variables: {
      limit: 100,
      offset: 0,
      buildingId: currentBuilding?.Id,
    },
  });
  const classes = useStyles();
  const theme = useTheme();
  useEffect(() => {
    if (data) {
      initFirebase();
    }
  }, [data]);

  const initFirebase = () => {
    if (!!getDatabase) {
      const database = getDatabase();
      let pendingTaskListener = database.ref(
        "buildings/" + currentBuilding?.Id + "/pendingTasks"
      );
      const roleTableRows: RoleTableRow[] = [];
      pendingTaskListener.on("value", (snapshot) => {
        const pendingTasks = snapshot.val();

        const roleTasks = snapshot.val();

        for (const key in roleTasks) {
          if (roleTasks.hasOwnProperty(key)) {
            const roleTask = roleTasks[key];

            let roleName = data?.Role.find((role) => {
              return role.Id === roleTask.roleId;
            })?.Title;
            if (!roleName) {
              roleName = "Any";
            }
            const tableRow = {
              taskName: roleTask.taskName,
              roleName,
              timeString: roleTask.timeString,
              priority: roleTask.priority,
            };
            roleTableRows.push(tableRow);
          }
        }

        setState({ ...state, roleTableRows, loading: false });
      });
    }
  };

  const loading = state.loading || rolesLoading;
  if (loading) {
    return <LinearProgress />;
  } else {
    return (
      <Fragment>
        <Paper className="container">
          <PerfectScrollbar>
            <Box>
              <Typography color="textPrimary" variant="h4">
                Pending Role Tasks
              </Typography>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Task Name</TableCell>
                    <TableCell>Role Name</TableCell>
                    <TableCell>Since</TableCell>
                    <TableCell>Priority</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {state.roleTableRows.map((tableRow: RoleTableRow) => (
                    <TableRow hover key={tableRow.timeString}>
                      <TableCell component="th" scope="row">
                        {tableRow.taskName}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {tableRow.roleName}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {tableRow.timeString}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {tableRow.priority}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </PerfectScrollbar>
        </Paper>
      </Fragment>
    );
  }
}
